import {message} from 'antd';

export const KToast: React.FC = () => {
  const [, contextHolder] = message.useMessage({});

  return <>{contextHolder}</>;
};
